/**
 * @constructor
 */
function PopupMenu(containerClass, animate, align) {
    align = align || "left";

    const self = this;
    let parent;

    /** @type {jQuery} */
    const $listview = $('<ul data-role="listview">');
    const $content = $('<div data-role="popup" data-overlay-theme="a" data-theme="f" class="scrollContent popup menu noFooter" data-history="false">')
        .append($listview)
        .attr("data-wrapper-class", containerClass + " menuContainer");

    const $button = $('<a href="#" class="menuButton" data-role="button" data-icon="mobile-menu" data-iconpos="notext" data-inline="true">');

    $button.on("click", function() {
        if ($button.hasClass("close")) {
            self.hide();
        } else {
            let left = $button.offset().left;
            parent = $button.parent();
            $button.addClass("close");
            $button.appendTo($("body"));
            $button.css("left", left);
            self.show();
        }
    });

    $content.on("popupafterclose", function() {
        $button.removeClass("close");
        $button.css("left", "");
        parent.append($button);
        parent = undefined;
    });

    this.getContent = function() {
        return $content;
    };

    this.getButton = function() {
        return $button;
    };

    /**
	 * Adds an entry to the options menu with the details provided
	 *
	 * @param title {string} - The text to be displayed on the menu item
	 * @param clickHandler {function} - The function to be called when the menu entry is cicked
	 * @param weight {number} - Position value fo ordering menu entries (larger values go higher in the list)
	 * @param iconClass {string?} - The icon class to be added to the entry (if applicable)
	 * @returns {jQuery} - The jQuery-wrapped element that was added to the menu
	 */
    this.addEntry = function(title, clickHandler, weight, iconClass) {
        // Build the menu item
        let $item = $("<li>", {"data-menu-weight" : weight});

        if (iconClass) {
            $item.attr("data-icon", iconClass);
            $item.append($("<a>", {text : title}));
        } else {
            $item.text(title);
        }

        $item.on("click", function() {
            $content.popup("close");

            if (clickHandler) {
                clickHandler();
            }
        });

        // Add it to the menu
        let menuItems = $listview.children();

        if (menuItems.length === 0) {
            $listview.append($item);
        } else {
            let done = false;
            menuItems.each(function() {
                if (!done && weight > $(this).attr("data-menu-weight")) {
                    $(this).before($item);
                    done = true;
                }
            });

            // If we didn't find a suitable place for this item append it to end of list
            if (!done) {
                $listview.append($item);
            }
        }

        return $item;
    };

    this.clear = function() {
        $listview.empty();
    };

    this.show = function() {
        if (animate || PopupMenu.animate) {
            $content.one("popupafteropen", function() {
                $content.css("visibility", "hidden");
                let left = $button.offset().left;

                if (align === "right") {
                    left += $button.outerWidth() - $content.outerWidth();
                }

                $content.css("left", left);

                let height = $content.outerHeight();
                $content.outerHeight(0);
                $content.css("visibility", "");
                $content.animate({height : height}, 200);
            });
            $content.on("popupafterclose", function() {
                $content.css("height", "");
            });
        }

        $content.popup("open");
    };

    this.hide = function() {
        $content.popup("close");
    };

    this.refresh = function() {
        $listview.listview("refresh");
    };
}

PopupMenu.animate = true;

module.exports = PopupMenu;